module.exports = __webpack_public_path__ + "static/scale-model-of-mattachine-steps-in-glendale-california-41459e5c58694b00f6a07e8a0448afe3.png";